/**
 * Drops requests that would reach the backend as exactly the same body.
 *
 * A single submission of the request form can fan out into several POSTs: the
 * mappers split attachments into groups that each fit under the maximum request
 * size. Two groups normally differ by the files they carry, but a customer who
 * uploads the same document into two slots produces two groups holding the same
 * file - and therefore two identical bodies.
 *
 * The integration service recognises the second one as a duplicate and answers
 * 409, which the form reports as success. Sending it at all is pointless: it
 * carries nothing the first request did not. Collapsing the pair here keeps one
 * user action to one backend process without relying on that rejection.
 *
 * Serialisation is plain JSON.stringify on purpose - every body in a fan-out is
 * built by the same mapper, so their keys are already in the same order.
 */
export const dedupeRequests = <T>(requests: T[]): T[] => {
    const seen = new Set<string>();

    return requests.filter((request) => {
        const key = JSON.stringify(request);
        if (seen.has(key)) {
            return false;
        }
        seen.add(key);
        return true;
    });
};
